import { render, staticRenderFns } from "./createEmp.vue?vue&type=template&id=f7054968&scoped=true&"
import script from "./createEmp.vue?vue&type=script&lang=js&"
export * from "./createEmp.vue?vue&type=script&lang=js&"
import style0 from "./createEmp.vue?vue&type=style&index=0&id=f7054968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7054968",
  null
  
)

export default component.exports